import axios from 'axios';

const getCotacoes = (params) => axios.get('/fornecedor/solicitacoes-respostas', {
  params,
});

const getCotacoesList = (params) => axios.get('/fornecedor/solicitacoes-respostas/list', {
  params,
});

export default {
  getCotacoes,
  getCotacoesList,
};
